import * as React  from 'react';
import { useEffect, useState, useReducer, useRef } from 'react';
import axios from 'axios';
import Alert from '../commons/alert'
import { getCsrfToken } from './registration/authenticityToken'
import LoadingOverlay from 'react-loading-overlay';

interface HTMLInputEvent<T extends HTMLElement> extends Event {
  target: T;
}

const dScheduleGuestParams = {
  name: '',
  name_kana: '',
  birthday: { year: '1980', month: '01', day: '01' },
  sex: '',
  mobile_phone: ''
};

const dScheduleParams = {
  memo: ''
};

const initialRegistrationParams = {
  dScheduleGuest: dScheduleGuestParams,
  d_schedule: dScheduleParams
};

function reducer(state, action) {
  return { ...state, ...action };
}

const PAGE = { FIRST: 'first', SECOND: 'second' }
const SEX = { MALE: '1', FEMALE: '2' }

const getSexText = (num) => {
  switch(num){
    case parseInt(SEX.MALE) :
      return '男'
    case parseInt(SEX.FEMALE) :
      return '女'
    default:
      return ''
  }
}

const Registration = (props) => {
  const [page, setPage] = useState(PAGE.FIRST);
  const [params, dispatch] = useReducer(reducer, initialRegistrationParams);
  const [dScheduleGuest, setDScheduleGuest] = useState(null);
  const [dSchedule, setDSchedule] = useState(null);
  const [alertMessages, setAlertMessages] = useState([]);
  const uploadCount = useRef(1);
  // 処方箋データ
  const [previewFileData, setPreviewFileData] = useState([]);
  // 保険証データ
  const [insuranceFileData, setInsuranceFileData] = useState([]);

  // 患者情報
  const [patient, setPatient] = useState({name: "", mobilePhoneNumber: "", genderKbn: "", birthday: ""});
  // エラーメッセージ
  const [errorMessage, setErrorMessage] = useState("");
  // ロード
  const [isLoading, setIsLoading]  = useState<Boolean>(true);

  // 初回ロード
  useEffect(() =>{
    axios.get(
      '/api/internal/reserves/get_profile?m_institution_key=' + props.institution_key, {})
      .then(function (response) {
        let m_patient = response.data.m_patient
        if (response.data.is_login) {
          onChangeScheduleGuest({ name: m_patient.name, 
                                  mobile_phone: m_patient.mobilePhoneNumber, 
                                  sex: m_patient.genderKbn, 
                                  birthday: { year: m_patient.birthday.year, month: m_patient.birthday.month, day: m_patient.birthday.day },
                                  sub: m_patient.sub
                                })
        }
        
        setIsLoading(false);
      })
      .catch(error => {
        setErrorMessage(error.response.data.message);
        setIsLoading(false);
      });
  },[])

  const onRegistrationConfirm = () => {
    setAlertMessages([]);
    const registForm = document.getElementById('registForm');

    if (registForm instanceof HTMLFormElement) {
      const formData = new FormData(registForm);

      axios.post(
        '/api/internal/reserves/registration_confirm',
         formData
      ).then(function (res) {
        if (res.data.status === 200){
          setDScheduleGuest(res.data.d_schedule_guest);
          setDSchedule(res.data.d_schedule);

          const prescription_files = document.getElementsByClassName('prescription-file-input');
          const insurance_files = document.getElementsByClassName('insurance-file-input');
          const previewFiles = []
          const insuranceFiles = []
          Array.prototype.forEach.call(prescription_files, (file) => {
            if (file instanceof HTMLInputElement && file.value != '') {
              previewFiles.push({ fileType: file.dataset.fileType, fileName: file.dataset.fileName, imgPath: file.dataset.imgPath})
            }
          })
          Array.prototype.forEach.call(insurance_files, (file) => {
            if (file instanceof HTMLInputElement && file.value != '') {
              insuranceFiles.push({ fileType: file.dataset.fileType, fileName: file.dataset.fileName, imgPath: file.dataset.imgPath})
            }
          })
          setPreviewFileData(previewFiles)
          setInsuranceFileData(insuranceFiles)

          setPage(PAGE.SECOND)
        } else {
          window.scrollTo(0, 0);
          setAlertMessages(res.data.message)
        }
      })
      .catch(function (error) {
        window.scrollTo(0, 0);
        setAlertMessages(error.response.data.message)
      });
    }
  }

  const onChangeScheduleGuest = (change) => {
    dispatch({ dScheduleGuest: { ...params.dScheduleGuest, ...change }});
  }

  const onChangeInputFile = (e, file_name) => {
    if (e.target.value) {
      const type = e.target.files[0].type;
      if(type.includes("image/")){
        previewFile(file_name, e.target.files[0], 1)
        document.getElementById(`${file_name}_reserves_custom1`).classList.remove('hidden');
      }else{
        onRemove(file_name, uploadCount.current);
        window.alert("画像ファイルを添付してください。");
      }

    }
  }

  const previewFile = (file_name ,file, count) => {
    const elemetFile = document.getElementById(`${file_name}File${count}`)
    elemetFile.dataset.fileType = file.type;
    elemetFile.dataset.fileName = file.name;
    elemetFile.dataset.imgPath = '';

    if (file.type.indexOf('image') != -1) {
      const reader = new FileReader();
      reader.onload = function (e) {
        const preview = document.getElementById(`${file_name}_preview${count}`)
        if (preview instanceof HTMLImageElement) {
          const imgPath = `${e.target.result}`
          preview.src = imgPath;
          elemetFile.dataset.imgPath = imgPath;
        }
      }
       reader.readAsDataURL(file);
    }
  }

  const onRemove = (file_name, count) => {
    const file = document.getElementById(`${file_name}File${count}`)
    const preview = document.getElementById(`${file_name}_preview${count}`)
    if (file instanceof HTMLInputElement) {
      file.value = '';
    }
    if (preview instanceof HTMLImageElement) {
      preview.src = '';
    }
    document.getElementById(`${file_name}_reserves_custom${count}`).classList.add('hidden');
  }

  const addFileInput = (file_name) => {
    const elementFile = document.getElementById(`${file_name}File${uploadCount.current}`);
    if (elementFile instanceof HTMLInputElement && elementFile.value == '') {
      elementFile.click();
      return;
    }

    const count = uploadCount.current + 1
    uploadCount.current = count;

    const fileElem = document.createElement('input');
    fileElem.type = 'file';
    fileElem.accept = "image/*";
    fileElem.name = `${file_name}_file[file${count}]`;
    fileElem.id = `${file_name}File${count}`;
    fileElem.classList.add(`${file_name}-file-input`, 'hidden');

    const divElem = document.createElement('div');
    divElem.classList.add('reserves-custom','hidden');
    divElem.id = `${file_name}_reserves_custom${count}`;

    const iconWrapElem = document.createElement('span');
    const removeBtn = document.createElement('span');
    removeBtn.classList.add('btn');
    const icon = document.createElement('span');
    icon.classList.add('glyphicon', 'glyphicon-trash');
    removeBtn.appendChild(icon);
    removeBtn.onclick = function() {
      onRemove(file_name, count);
    };
    iconWrapElem.appendChild(removeBtn);

    const imageWrapElem = document.createElement('span');
    imageWrapElem.classList.add('preview-content')
    const imgElem = document.createElement("img");
    imgElem.id = `${file_name}_preview${count}`
    imgElem.classList.add('preview-img');
    const fileNameElem = document.createElement('span');
    fileNameElem.classList.add('file_name');
    imageWrapElem.appendChild(imgElem);
    imageWrapElem.appendChild(fileNameElem);

    divElem.appendChild(fileElem);
    divElem.appendChild(iconWrapElem);
    divElem.appendChild(imageWrapElem);

    const fileInputArea = document.getElementById(`${file_name}_file_input_area`);
    fileInputArea.appendChild(divElem);

    fileElem.addEventListener('change', (e: HTMLInputEvent<HTMLInputElement>) => {
      if (fileElem.value) {
        const file = e.target.files[0];
        const type = e.target.files[0].type;
        if(type.includes("image/")){
          previewFile(file_name, file, count);
          document.getElementById(`${file_name}_reserves_custom${count}`).classList.remove('hidden');
        }else{
          onRemove(file_name, uploadCount.current);
          window.alert("画像ファイルを添付してください。");
          return
        }
      }
    });

    fileElem.click();
  }

  return(
    <LoadingOverlay
    active={isLoading}
    spinner
    text='Loading...'
    >
      <form className="registration-form"
            action={`/${props.institution_key}/reserves/registration_complete`}
            acceptCharset="UTF-8"
            method="post"
            encType="multipart/form-data"
            id="registForm"
      >
        { alertMessages.length > 0 && <Alert messages={alertMessages} />}

        <input name="utf8" type="hidden" value="✓" />
        <input name="authenticity_token" type="hidden" value={getCsrfToken()} />
        <input name="d_schedule_guest[cognito_sub]" type="hidden" id="d_schedule_guest_cognito_sub" value={params.dScheduleGuest.sub} />
        {page == PAGE.FIRST ? (
          <>
            <div className="form-group">
              <label htmlFor="d_schedule_guest_name">お名前</label>
              <span className="label label-danger ml5">必須</span>
              <input type="text"
                     name="d_schedule_guest[name]"
                     id="d_schedule_guest_name"
                     className="form-control"
                     placeholder="山田太郎"
                     onChange={e => onChangeScheduleGuest({ name: e.target.value })}
                     value={params.dScheduleGuest.name}
                     style={{}} />
            </div>
            <div className="form-group">
              <label htmlFor="d_schedule_guest_name_kana">お名前カナ</label>
              <input type="text"
                     name="d_schedule_guest[name_kana]"
                     id="d_schedule_guest_name_kana"
                     className="form-control"
                     placeholder="ヤマダタロウ"
                     onChange={e => onChangeScheduleGuest({ name_kana: e.target.value })}
                     value={params.dScheduleGuest.name_kana}
                     style={{}} />
            </div>
            <div className="form-group">
              <label htmlFor="birthday">生年月日</label>
              <div className=" form-inline">
                <select name="d_schedule_guest[birthday][year]"
                        id="m_patient_birthday_day"
                        className="form-control col-offset-1-xs-3 patient_field"
                        onChange={e => onChangeScheduleGuest({ birthday: { ...params.dScheduleGuest.birthday, ...({ year: e.target.value })}})}
                        value={params.dScheduleGuest.birthday.year}
                        style={{ width: '35%', display: 'inline' }}>
                  {props.date_of_birth_options['year'].map((kbn, i) => (
                    <option value={kbn.value} key={i}>{kbn.name}</option>
                  ))}
                </select>
                &nbsp;月&nbsp;
                <select name="d_schedule_guest[birthday][month]"
                        id="m_patient_birthday_month"
                        className="form-control col-offset-1-xs-3 patient_field"
                        onChange={e => onChangeScheduleGuest({ birthday: { ...params.dScheduleGuest.birthday, ...({ month: e.target.value })}})}
                        value={params.dScheduleGuest.birthday.month}
                        style={{ width: '25%', display: 'inline' }}>
                  {props.date_of_birth_options['month'].map((kbn, i) => (
                    <option value={kbn.value} key={i}>{kbn.name}</option>
                  ))}
                </select>
                &nbsp;月&nbsp;
                <select name="d_schedule_guest[birthday][day]"
                        id="m_patient_birthday_day"
                        className="form-control col-offset-1-xs-3 patient_field"
                        onChange={e => onChangeScheduleGuest({ birthday: { ...params.dScheduleGuest.birthday, ...({ day: e.target.value })}})}
                        value={params.dScheduleGuest.birthday.day}
                        style={{ width: '25%', display: 'inline' }}>
                  {props.date_of_birth_options['day'].map((kbn, i) => (
                    <option value={kbn.value} key={i}>{kbn.name}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className="form-group">
              <label>性別</label>
              <div className="radio-inline">
                <input type="radio"
                       name="d_schedule_guest[sex]"
                       id="d_schedule_guest_sex_1"
                       value={SEX.MALE}
                       onChange={e => onChangeScheduleGuest({ sex: e.target.value })}
                       checked={params.dScheduleGuest.sex == SEX.MALE}
                       className="radio-input" />
                <label htmlFor="d_schedule_guest_sex_1">男性</label>
              </div>
              <div className="radio-inline">
                <input type="radio"
                       name="d_schedule_guest[sex]"
                       id="d_schedule_guest_sex_2"
                       value={SEX.FEMALE}
                       onChange={e => onChangeScheduleGuest({ sex: e.target.value })}
                       checked={params.dScheduleGuest.sex == SEX.FEMALE}
                       className="radio-input" />
                <label htmlFor="d_schedule_guest_sex_2">女性</label>
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="d_schedule_guest_mobile_phone">携帯電話番号</label>
              <span className="label label-danger ml5">必須</span>
              <input type="text"
                     name="d_schedule_guest[mobile_phone]"
                     id="d_schedule_guest_mobile_phone"
                     className="form-control patient_field"
                     onChange={e => onChangeScheduleGuest({ mobile_phone: e.target.value })}
                     placeholder="09000000000"
                     value={params.dScheduleGuest.mobile_phone}
                     style={{width: '100%'}} />
            </div>
            <div className="form-group">
              <label htmlFor="d_schedule_memo">備考</label>
              <textarea name="d_schedule[memo]"
                        id="d_schedule_memo"
                        className="form-control"
                        onChange={e => dispatch({ d_schedule: { ...params.d_schedule, ...({ memo: e.target.value }) }})}
                        value={params.d_schedule.memo}
                        rows={5}></textarea>
            </div>
            <input type="hidden" name="d_schedule[plan_datetime_from]" id="d_schedule_plan_datetime_from" value={props.plan_datetime_from} />
            <input type="hidden" name="institution_key" id="institution_key" value={props.institution_key} />
          </>
        ) : (
          <>
            <h3>予約内容</h3>
            <br />
            <table className="table table-bordered">
              <tbody>
                <tr>
                  <td className="text-center" style={{ width: '36%' }}><label>お名前</label></td>
                  <td style={{ width: '64%' }}>{dScheduleGuest.name}</td>
                </tr>
                <tr>
                  <td className="text-center"><label>お名前カナ</label></td>
                  <td>{dScheduleGuest.name_kana}</td>
                </tr>
                <tr>
                  <td className="text-center"><label>生年月日</label></td>
                  <td>{dScheduleGuest.disp_birthday}</td>
                </tr>
                <tr>
                  <td className="text-center"><label>性別</label></td>
                  <td>{getSexText(dScheduleGuest.sex)}</td>
                </tr>
                <tr>
                  <td className="text-center"><label>携帯電話番号</label></td>
                  <td>{dScheduleGuest.mobile_phone}</td>
                </tr>
                <tr>
                  <td className="text-center"><label>備考</label></td>
                  <td>{dSchedule.memo ? <pre className="pre-reserve-memo">{dSchedule.memo}</pre> : null}</td>
                </tr>
                {
                  !props.is_clinic && (
                    <tr>
                      <td className="text-center"><label>処方箋を添付</label></td>
                      <td>
                        {previewFileData.length > 0 ? `${previewFileData.length}枚` : ''}
                        {previewFileData.map((previewFile, i) => (
                          <div key={"prescription_" + i} className="mt10">
                            {
                              previewFile.fileType && (
                                <img src={previewFile.imgPath} />
                              )
                            }
                          </div>
                        ))}
                      </td>
                    </tr>
                  )
                }

                <tr>
                  <td className="text-center"><label>{props.is_clinic ? "資格確認証を添付" : "保険証を添付"}</label></td>
                  <td>
                    {insuranceFileData.length > 0 ? `${insuranceFileData.length}枚` : ''}
                    {insuranceFileData.map((previewFile, i) => (
                      <div key={"insurance_" + i} className="mt10">
                        {
                          previewFile.fileType && (
                            <img src={previewFile.imgPath} />
                          )
                        }
                      </div>
                    ))}
                  </td>
                </tr>
              </tbody>
            </table>
            <input type="hidden" name="d_schedule_guest[name]" value={dScheduleGuest.name} />
            <input type="hidden" name="d_schedule_guest[name_kana]" value={dScheduleGuest.name_kana} />
            <input type="hidden" name="d_schedule_guest[birthday]" value={dScheduleGuest.birthday} />
            <input type="hidden" name="d_schedule_guest[sex]" value={dScheduleGuest.sex ? dScheduleGuest.sex: ''} />
            <input type="hidden" name="d_schedule_guest[mobile_phone]" value={dScheduleGuest.mobile_phone} />
            <input type="hidden" name="d_schedule[memo]" value={dSchedule.memo} />
            <input type="hidden" name="d_schedule[plan_datetime_from]" id="d_schedule_plan_datetime_from" value={props.plan_datetime_from} />
          </>
        )}
        
        {page == PAGE.FIRST && (
          
          !props.is_clinic && (
          
            <div className="form-group">
              {
                props.is_prescription_required ? (
                  <>
                    <label>処方箋を添付</label>
                    <span className="label label-danger ml5">必須</span>
                  </>
                ):(
                  <label>処方箋を添付（※FAX・LINE・処方箋送信などで既に処方箋を送信頂いている方の添付は不要です。）</label>
                )
              }
              <br />
              <div className="btn btn-info add-prescription-btn" onClick={() => addFileInput("prescription")}>
                <span className="glyphicon glyphicon-camera mr10" aria-hidden="true"></span>
                写真を撮る（ファイル添付）
              </div>
            </div>
          )
        )}
        <div className="form-group">
          <div id="prescription_file_input_area" style={{ display: page == PAGE.FIRST ? 'block' : 'none' }}>
            <div id="prescription_reserves_custom1" className="reserves-custom hidden">
              <input type="file" name="prescription_file[file1]" id="prescriptionFile1" className="prescription-file-input hidden" accept="image/*" onChange={(e) => onChangeInputFile(e, "prescription")} />
              <span>
                <span className="btn" onClick={() => onRemove("prescription", 1)}>
                  <span className="glyphicon glyphicon-trash" aria-hidden="true"></span>
                </span>
              </span>
              <span className="preview-content">
                <img id="prescription_preview1" className="preview-img" src="" />
                <span className="file_name"></span>
              </span>
            </div>
          </div>
        </div>

        {page == PAGE.FIRST && (
          <div className="form-group">
            <label>{props.is_clinic ? "資格確認証を添付（※マイナ保険証をお持ちでない方は資格確認証の写真を添付してください。）":"保険証を添付"}</label>
            {
              props.is_insurance_card_required && (
                <span className="label label-danger ml5">必須</span>
              )
            }
            <br />
            <div className="btn btn-info add-prescription-btn" onClick={() => addFileInput("insurance")}>
              <span className="glyphicon glyphicon-camera mr10" aria-hidden="true"></span>
              写真を撮る（ファイル添付）
            </div>
          </div>
        )}
        <div className="form-group">
          <div id="insurance_file_input_area" style={{ display: page == PAGE.FIRST ? 'block' : 'none' }}>
            <div id="insurance_reserves_custom1" className="reserves-custom hidden">
              <input type="file" name="insurance_file[file1]" id="insuranceFile1" className="insurance-file-input hidden" accept="image/*" onChange={(e) => onChangeInputFile(e, "insurance") } />
              <span>
                <span className="btn" onClick={() => onRemove("insurance", 1)}>
                  <span className="glyphicon glyphicon-trash" aria-hidden="true"></span>
                </span>
              </span>
              <span className="preview-content">
                <img id="insurance_preview1" className="preview-img" src="" />
                <span className="file_name"></span>
              </span>
            </div>
          </div>
        </div>
        {page == PAGE.FIRST ? (
          <button type="button" className="btn btn-primary center-block mt40" onClick={onRegistrationConfirm}>
            確認画面へ進む
          </button>
        ) : (
          <>
            <button type="button" className="btn btn-primary pull-left mt40"  onClick={() => setPage(PAGE.FIRST)}>
              戻る
            </button>
            <input type="submit" name="" value="予約を申し込む" className="btn btn-primary pull-right mt40" data-disable-with="予約を申し込む" />
          </>
        )}
      </form>
    </LoadingOverlay>
  );
}

export default Registration
